import {css} from 'aphrodite';
import React from 'react';

import Button, {ButtonStyle, ButtonSize} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import runModal from 'ui-library/runModal';

import {
  InputFileNamePart,
  InputFileNamePartType,
} from '../automation-input-file-config/AutomationInputFileConfigConstants';
import InputFileNameTemplate from '../automation-input-file-config/InputFileNameTemplate';
import SetInputFileNameTemplateModal from '../automation-input-file-config/SetInputFileNameTemplateModal';
import {
  AutomationOutputFileConfigEditorProps,
  automationFileConfigStyles,
  SectionNumber,
} from '../AutomationFileConfigUtils';

const defaultNameTemplateParts: Array<InputFileNamePart> = [
  {type: InputFileNamePartType.RUN_SCHEMA_NAME},
  {type: InputFileNamePartType.TEXT, text: '_'},
  {type: InputFileNamePartType.CREATED_AT_DATE},
  {type: InputFileNamePartType.TEXT, text: 'T'},
  {type: InputFileNamePartType.CREATED_AT_TIME},
];

export default function AutomationOutputFileConfigEditorDatasetSection(
  props: AutomationOutputFileConfigEditorProps
): JSX.Element {
  return (
    <div className={css(automationFileConfigStyles.subsection)}>
      <SectionNumber sectionNumber={7} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure dataset</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        Choose a naming convention that describes your dataset clearly and succinctly
      </div>
      <div className={css(automationFileConfigStyles.formatSectionContents)}>
        <div className={css(automationFileConfigStyles.formatSectionItem)}>
          <FieldLabel label="Dataset name" labelStyle={LabelStyle.LABEL} />
          <br />
          <InputFileNameTemplate
            nameTemplateParts={props.outputFileConfig.datasetNameTemplateParts ?? defaultNameTemplateParts}
            schemaFields={props.baseSchema.allFields}
          />
          <Button
            icon="edit"
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={() => {
              runModal(SetInputFileNameTemplateModal, {
                runSchema: props.baseSchema,
                automationFileConfig: props.outputFileConfig,
                forOutputFileConfig: true,
                initialNameTemplateParts:
                  props.outputFileConfig.datasetNameTemplateParts ?? defaultNameTemplateParts,
                onRequestSubmit: (datasetNameTemplateParts) => {
                  props.onUpdateConfig({
                    ...props.outputFileConfig,
                    datasetNameTemplateParts,
                  });
                },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}
